
export const getSlicedLeftSubNavigationItems = (navigationItem) => {
    const slicedLeftSubNavigationItemIds = navigationItem?.slicedLeftSubNavigationItemIds;
    if(!slicedLeftSubNavigationItemIds) {
        return [];
    }
    return slicedLeftSubNavigationItemIds.map((id) =>
        navigationItem.subNavigationItems.find((subItem) => subItem.id === id),
    );
};

export const getSlicedTopSubNavigationItems = (navigationItem) => {
    const slicedTopSubNavigationItemIds = navigationItem?.slicedTopSubNavigationItemIds;
    if(!slicedTopSubNavigationItemIds) {
        return [];
    }
    return slicedTopSubNavigationItemIds.map((id) =>
        navigationItem.subNavigationItems.find((subItem) => subItem.id === id),
    );
};

